import React from "react";
import styles from "./LayoutSidebar.module.scss";
import { IoClose } from "react-icons/io5";
import { toggleSidebar } from "../model/slice";
import { useDispatch, useSelector } from "react-redux";
import { selectIsSidebarOpen } from "../model/selector";

export const LayoutSidebar = () => {
  const dispatch = useDispatch();
  const isSidebarOpen = useSelector(selectIsSidebarOpen);

  const handleToggleSidebar = () => {
    dispatch(toggleSidebar());
  };

  return (
    <>
      <div
        className={`${styles.overlay} ${isSidebarOpen ? styles.open : ""}`}
        onClick={() => handleToggleSidebar()}
      />
      <div className={`${styles.sidebar} ${isSidebarOpen ? styles.open : ""}`}>

        <div className={styles.sidebarHeader}>
          <img src="logo1.png" alt="X" className={styles.logo} />
          <div>
            <IoClose
              className={styles.closeIcon}
              onClick={() => handleToggleSidebar()}
            />
          </div>
        </div>
      </div>
    </>
  );
};
